import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import PropTypesHelpers from '../../utils/propTypesHelpers'

const ButtonClose = ({ onClick, label = 'Close', className, ...props }) => (
  <button
    type='button'
    className={classnames('close', 'qa-close-btn', className)}
    aria-label={label}
    onClick={onClick}
    {...props}
  >
    <span aria-hidden='true'><FontAwesomeIcon icon={faTimesCircle} /></span>
  </button>
)

ButtonClose.propTypes = {
  className: PropTypesHelpers.classnames,
  onClick: PropTypes.func,
  label: PropTypes.string
}

export default ButtonClose
